import React from 'react';
import { startCase } from 'lodash';
import Form from 'mobx-react-form';
import { Grid, InputAdornment, TableCell, TableRow } from '@mui/material';

import { getInputStyles } from './IncomeAdjustmentRow';
import NumericInput from 'components/shared/inputs/NumericInput';
import { ConclusionType } from '../types';

type DiscountRateRowsProps = {
  form: Form;
  type: ConclusionType;
  discountRate?: number;
  marketValueWithDiscount?: string | null;
};

const DiscountRateRows = ({ type, discountRate, marketValueWithDiscount, form }: DiscountRateRowsProps) => {
  return (
    <>
      <TableRow>
        <TableCell>
          <Grid container>
            <Grid item xs={6}>
              Discount Rate of
            </Grid>
            <Grid item xs={3}>
              <NumericInput
                sx={{ ...getInputStyles(true) }}
                {...form.$(`incomeApproach.capRateConclusion.${type}DiscountPercentage`).bind()}
                onFocus={(event) => event.target?.select()}
                allowNegative={false}
                fullWidth={false}
                placeholder="0"
                margin="none"
                thousandSeparator
                decimalScale={0}
                InputProps={{
                  sx: { paddingRight: 0 },
                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
              />
            </Grid>
          </Grid>
        </TableCell>
        <TableCell>
          <Grid container>
            <Grid item xs={5}>
              annualized, for
            </Grid>
            <Grid item xs={4}>
              <NumericInput
                sx={{ ...getInputStyles(true) }}
                {...form.$(`incomeApproach.capRateConclusion.${type}MonthsDiscounted`).bind()}
                onFocus={(event) => event.target?.select()}
                margin="none"
                allowNegative={false}
                autoComplete="off"
                placeholder="0"
                InputProps={{
                  sx: { paddingRight: 0 },
                  endAdornment: <InputAdornment position="end">months</InputAdornment>,
                }}
              />
            </Grid>
          </Grid>
        </TableCell>
        <TableCell align="right">
          <NumericInput
            sx={{ ...getInputStyles(true) }}
            value={discountRate}
            onFocus={(event) => event.target?.select()}
            allowNegative={false}
            autoComplete="off"
            margin="none"
            decimalScale={4}
            disabled
            placeholder="0.00"
          />
        </TableCell>
        <TableCell>&nbsp;</TableCell>
        <TableCell>&nbsp;</TableCell>
      </TableRow>
      <TableRow>
        <TableCell>{startCase(type)} Market Value with discounting applied</TableCell>
        <TableCell>&nbsp;</TableCell>
        <TableCell align="right">
          <NumericInput
            sx={{ ...getInputStyles(true) }}
            value={marketValueWithDiscount || '$0'}
            allowNegative={false}
            autoComplete="off"
            decimalScale={2}
            margin="none"
            disabled
            placeholder="$0.00"
            prefix="$"
            thousandSeparator
          />
        </TableCell>
        <TableCell>&nbsp;</TableCell>
        <TableCell>&nbsp;</TableCell>
      </TableRow>
    </>
  );
};

export default DiscountRateRows;
